import React from 'react';
import { BrandColor } from '@styleseat/brand';

type InstagramLogoCircleProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const InstagramCircleIcon = ({
  width = 24,
  height = 24,
  color = BrandColor.BackInBlack,
}: InstagramLogoCircleProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 42 43"
    fill={color}
  >
    <path
      d="M42 21.0278C42 31.629 34.1374 40.3929 23.924 41.8155C22.9687 41.9485 21.9916 42.0174 21 42.0174C19.8548 42.0174 18.7314 41.9255 17.6358 41.749C7.63769 40.1403 0 31.4743 0 21.0266C0 9.43441 9.40201 0.0371094 21 0.0371094C32.598 0.0371094 42 9.43441 42 21.0266V21.0278Z"
      fill="#1C1C1B"
    />
    <path
      d="M27.4937 7.84705H14.5063C10.9182 7.84705 8 10.8226 8 14.4811V26.5964C8 30.2549 10.9182 33.2305 14.5063 33.2305H27.4937C31.0818 33.2305 34 30.2549 34 26.5964V14.4811C34 10.8226 31.0818 7.84705 27.4937 7.84705ZM10.2949 14.4811C10.2949 12.1131 12.1839 10.1871 14.5063 10.1871H27.4937C29.8161 10.1871 31.7051 12.1131 31.7051 14.4811V26.5964C31.7051 28.9644 29.8161 30.8904 27.4937 30.8904H14.5063C12.1839 30.8904 10.2949 28.9644 10.2949 26.5964V14.4811Z"
      fill="white"
    />
    <path
      d="M21.5 26.3968C24.5327 26.3968 27 23.769 27 20.5391C27 17.3092 24.5327 14.6814 21.5 14.6814C18.4674 14.6814 16 17.3092 16 20.5391C16 23.769 18.4674 26.3968 21.5 26.3968ZM21.5 16.9036C23.3825 16.9036 24.9135 18.5342 24.9135 20.5391C24.9135 22.5441 23.3825 24.1746 21.5 24.1746C19.6175 24.1746 18.0865 22.5441 18.0865 20.5391C18.0865 18.5342 19.6175 16.9036 21.5 16.9036Z"
      fill="white"
    />
  </svg>
);
